import React from "react";
import { eventClick } from "../services/adobeDataLayer";

function Header(props) {
  return (
    <>
      <header className="d-flex align-items-center">
        <a href="">
          <img
          onClick={() => {eventClick("Header Logo", "Logo", "Banner")}}
            src={props.path}
            alt="ICICI Bank Logo"
            width={252}
            height={50}
            className="img-fluid"
          />
        </a>
        <h2 onClick={() => {eventClick("Header Logo", "Heading", "Banner")}}>Gold Loans</h2>
      </header>
    </>
  );
}

export default Header;
